var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.item.classes},_vm._l((_vm.item.lines),function(line,index){return _c('p',{key:index,class:line.classes,domProps:{"innerHTML":_vm._s(line.html)}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }